import { Action } from 'redux';
import { MODALS, ModalProps } from '@/features/modal/types';

// Action Types Enum
export enum ModalActionType {
  // Legacy actions
  ShowBalanceUpdate = 'SHOW_BALANCE_UPDATE',
  ShowUserIsPepOrHioLogout = 'SHOW_USER_IS_PEP_OR_HIO_LOGOUT',
  SetFtdExitIntentShown = 'SET_FTD_EXIT_INTENT_SHOWN',
  // New modal system actions
  ModalOpen = 'MODAL_OPEN',
  ModalClose = 'MODAL_CLOSE',
  ModalReset = 'MODAL_RESET',
  ModalResetExcluded = 'MODAL_RESET_EXCLUDED',
  ModalCloseAll = 'MODAL_CLOSE_ALL',
}

// Legacy Action Types
export type ShowBalanceUpdateAction = Action<ModalActionType.ShowBalanceUpdate> & {
  isShown: boolean;
};

export type ShowUserIsPepOrHioLogoutAction = Action<ModalActionType.ShowUserIsPepOrHioLogout> & {
  isShown: boolean;
};

export type SetFtdExitIntentShownAction = Action<ModalActionType.SetFtdExitIntentShown>;

// New Modal System Action Types
export type ModalOpenAction = Action<ModalActionType.ModalOpen> & {
  modal: MODALS;
  props?: ModalProps;
};

export type ModalCloseAction = Action<ModalActionType.ModalClose> & {
  modal?: MODALS;
};

export type ModalResetAction = Action<ModalActionType.ModalReset>;

export type ModalResetExcludedAction = Action<ModalActionType.ModalResetExcluded> & {
  excludedModals: MODALS[];
};

export type ModalCloseAllAction = Action<ModalActionType.ModalCloseAll> & {
  exceptions?: MODALS[];
};

// Union type of all actions
export type ModalActions =
  | ShowBalanceUpdateAction
  | ShowUserIsPepOrHioLogoutAction
  | SetFtdExitIntentShownAction
  | ModalOpenAction
  | ModalCloseAction
  | ModalResetAction
  | ModalResetExcludedAction
  | ModalCloseAllAction;

// Legacy Action Creators
export const setShowBalanceUpdate = (isShown: boolean): ShowBalanceUpdateAction => ({
  type: ModalActionType.ShowBalanceUpdate,
  isShown,
});

export const setShowUserIsPepOrHioLogout = (isShown: boolean): ShowUserIsPepOrHioLogoutAction => ({
  type: ModalActionType.ShowUserIsPepOrHioLogout,
  isShown,
});

export const setFtdExitIntentShown = (): SetFtdExitIntentShownAction => ({
  type: ModalActionType.SetFtdExitIntentShown,
});

// New Modal System Action Creators
export const modalOpen = <T extends MODALS>(modal: T, props?: ModalProps): ModalOpenAction => ({
  type: ModalActionType.ModalOpen,
  modal,
  props,
});

export const modalClose = (modal?: MODALS): ModalCloseAction => ({
  type: ModalActionType.ModalClose,
  modal,
});

export const modalReset = (): ModalResetAction => ({
  type: ModalActionType.ModalReset,
});

export const modalResetExcluded = (excludedModals: MODALS[]): ModalResetExcludedAction => ({
  type: ModalActionType.ModalResetExcluded,
  excludedModals,
});

export const modalCloseAll = (exceptions?: MODALS[]): ModalCloseAllAction => ({
  type: ModalActionType.ModalCloseAll,
  exceptions,
});
